import { Box, Tab, Tabs } from '@material-ui/core';
import { useState } from 'react';
import { TabExamTaskGroupSolutionScore } from '../../reducers/assessmentSessionReducer/assessmentSessionSlice';
import { Prompt } from '../Prompt/Prompt.component';


interface TabsBarProps {
  isFullscreen: boolean;
  isShelfAssessing: boolean;
  activeTabIndex: number;
  tabs: TabExamTaskGroupSolutionScore[];
  onChangeTab: (value: number) => void;
  tabIndexesWithUnsavedShelf: number[];
  tabHeight: number;
}

const TabsBar: React.FC<TabsBarProps> = ({
  isFullscreen,
  activeTabIndex,
  isShelfAssessing,
  tabs,
  onChangeTab,
  tabIndexesWithUnsavedShelf,
  tabHeight
}) => {
  const [isLeavingTabPromptOpen, setIsLeavingTabPromptOpen] = useState<boolean>(false);
  const [tabIndexPending, setTabIndexPending] = useState<number | null>(null);

  return (
    <>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          width: isFullscreen ? '100%' : 'calc(100% - 60px)',
          height: `${tabHeight}px`,
          alignItems: 'center',
        }}
      >
        <Tabs
          value={activeTabIndex}
          onChange={(event: unknown, newValue: number) => {
            if (isShelfAssessing) {
              setIsLeavingTabPromptOpen(true);
              setTabIndexPending(newValue);
              return;
            }

            onChangeTab && onChangeTab(newValue);
          }}
          aria-label="zakładki z kartami"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((additionalExamTaskGroupSolutionScore, index) => {
            const hasUnsavedShelf = tabIndexesWithUnsavedShelf.some((item) => item === index);
            return (
              <Tab
                disableRipple
                label={`${additionalExamTaskGroupSolutionScore.id}${hasUnsavedShelf ? '*' : ''}`}
                key={additionalExamTaskGroupSolutionScore.id}
              />
            );
          })}
        </Tabs>
      </Box>

      <Prompt
        type="confirmation"
        isBold={true}
        size={'xs'}
        open={isLeavingTabPromptOpen}
        mainText="Czy na pewno chcesz opuścić zakładkę?"
        subTexts={[{ text: 'Wprowadzone zmiany nie zostaną zapisane' }]}
        mainActionButtonText="Tak"
        onConfirm={() => {
          if (tabIndexPending !== null && onChangeTab) {
            onChangeTab(tabIndexPending);
            setIsLeavingTabPromptOpen(false);
            setTabIndexPending(null);
          }
        }}
        onCancel={() => setIsLeavingTabPromptOpen(false)}
      />
    </>
  );
};

export default TabsBar;
